export class DuplicateInviteRequestError extends Error {}
